<div class="search-options"  style="    min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">

  <mat-form-field class="header-form-full-width">
    <span class="label">{{'Customer' | translate | async}}</span>
    <mat-select id="select-customer" placeholder="{{'Select Customer' | translate | async}}" [(ngModel)]="selectedCustomer"
        (selectionChange)="loadJobsitesForCustomer();FilterFamilyForCustomer();" ngDefaultControl  multiple>
        <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
            {{customer.Name}}
        </mat-option>
    </mat-select>
</mat-form-field>




<mat-form-field class="header-form-full-width">
  <span class="label">{{'Implement Type' | translate | async}}</span>
  <mat-select id="select-equipment-implement-type" placeholder="{{'Select Implement Type' | translate | async}}"
  [(ngModel)]="selectedImplementType" ngDefaultControl  (selectionChange)="onSelectImplementType()" multiple>
  <mat-option [value]="implement.Id" *ngFor="let implement of implementTypeList">
    {{implement.Name}}
  </mat-option>
</mat-select>
</mat-form-field>

<mat-form-field class="header-form-full-width">
  <span class="label">{{'Implement Serial' | translate | async}}</span>
  <mat-select id="select-implement-serial" placeholder="{{'Select Implement' | translate | async}}" [(ngModel)]="selectedImplement"
  style="margin-bottom: 10px;" (selectionChange)="onImplementSelected()" ngDefaultControl  multiple>
  <mat-option [value]="impl.ImplementId" *ngFor="let impl of implementList">
    {{impl.Name}}
  </mat-option>
</mat-select>
</mat-form-field>


<mat-form-field class="header-form-full-width">
  <span class="label">{{'Job Site' | translate | async}}</span>
  <mat-select id="select-jobsite" placeholder="{{'Select Job Site' | translate | async}}" [(ngModel)]="selectedJobsite"
      (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl  multiple>
      <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
          {{jobsite.Name}}
      </mat-option>
  </mat-select>
</mat-form-field>





<mat-form-field class="header-form-full-width">
  <span class="label">{{'Family' | translate | async}}</span>
  <mat-select id="select-family" placeholder="{{'Select Family' | translate | async}}" [(ngModel)]="selectedFamily"
          (selectionChange)="loadModelList()" ngDefaultControl  multiple>
          <mat-option [value]="family.Id" *ngFor="let family of familyList">
            {{family.Name}}
          </mat-option>
        </mat-select>
</mat-form-field>

<mat-form-field class="header-form-full-width">
  <span class="label">{{'Model' | translate | async}}</span>
  <mat-select id="select-model" placeholder="{{'Select Model' | translate | async}}" [(ngModel)]="selectedModel" ngDefaultControl 
          multiple>
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
</mat-form-field>

<mat-form-field class="header-form-full-width">
  <span class="label">{{'Repairer' | translate | async}}</span>
  <mat-select id="select-equipment-repairer" placeholder="{{'Select Repairer' | translate | async}}" [(ngModel)]="selectedRepairer"
  ngDefaultControl  (selectionChange)="onSelectRepairer()" multiple>
  <mat-option [value]="repairer.Id" *ngFor="let repairer of repairerList">
    {{repairer.Name}}
  </mat-option>
</mat-select>
</mat-form-field>

<section class="evaluation-middle">
  <span style="margin-right: 1%;">{{'Implement Rebuild\'s Status' | translate | async}}</span>
  <mat-checkbox  style="margin-right: 1%;"[(ngModel)]="readytoRebuild" > {{'Ready to Rebuild' | translate | async}}</mat-checkbox>
  <mat-checkbox style="margin-right: 1%;" [(ngModel)]="preShipped" >{{'Pre Shipped' | translate | async}}</mat-checkbox>
  <mat-checkbox style="margin-right: 1%;"  [(ngModel)]="shipped" >{{'Shipped' | translate | async}}</mat-checkbox>
  <mat-checkbox  style="margin-right: 1%;"[(ngModel)]="disassembled" >  {{'Disassembled' | translate | async}}  </mat-checkbox>
  <mat-checkbox style="margin-right: 1%;"[(ngModel)]="sow" >{{'SOW-Approvals' | translate | async}}  </mat-checkbox>
  <mat-checkbox style="margin-right: 1%;"[(ngModel)]="wip" >{{'WIP' | translate | async}}</mat-checkbox>
  <mat-checkbox style="margin-right: 1%;"[(ngModel)]="readytoShip" >{{'Ready to Ship' | translate | async}}  </mat-checkbox>
  <mat-checkbox style="margin-right: 1%;"[(ngModel)]="complete" >{{'Complete' | translate | async}}</mat-checkbox>
</section>



<div class="bottom-row">

  <div class="flex flex--align-center">
  <a class="button button--primary" (click)="OpenMovetoInventory()">
    <i class="material-icons button__icon">swap_vertical_circle</i>
    <span class="button__text">{{'Remove Component From Equipment' | translate | async}}</span>
  </a>

  <a class="button button--primary" (click)="OpenCreteNewImplement()">
    <span class="button__text">{{'Create New Component' | translate | async}}</span>
  </a>
</div>
  <div class="flex flex--align-center">
      <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
      <a class="button button--primary" (click)="submitSelection()"><i class="material-icons button__icon">search</i><span
              class="button__text">{{'Perform Search' | translate | async}}</span></a>

            
  </div>
</div>

 
</div>